import React from 'react';
import { useLocation, type Location } from 'react-router-dom';

export function withRouter<P extends { location?: Location }>(
  Component: React.ComponentType<P>,
): React.ComponentType<Omit<P, 'location'>> {
  function Wrapped(props: Omit<P, 'location'>) {
    const location = useLocation();
    return <Component {...(props as P)} location={location} />;
  }

  Wrapped.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
}
